import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import DefaultLayout from './components/template/layouts/DefaultLayout'
import LoginLayout from './components/template/layouts/LoginLayout'
import ExamLayout from './components/template/layouts/ExamLayout'
import Notifications from 'vue-notification'
import LoadScript from 'vue-plugin-load-script'
import axios from 'axios'
import VueAxios from 'vue-axios'
import VueVideoWrapper from 'vue-video-wrapper'
import VueApexCharts from 'vue-apexcharts'
import VueCountdown from '@chenfengyuan/vue-countdown';
import SweetModal from 'sweet-modal-vue/src/plugin.js'
import { StripePlugin } from '@vue-stripe/vue-stripe';
import moment from 'moment'

Vue.use(VueVideoWrapper)
Vue.use(VueAxios, axios)
Vue.use(LoadScript)
Vue.use(SweetModal)
Vue.use(Notifications)
Vue.use(VueApexCharts)
Vue.component('apexchart', VueApexCharts)
Vue.component('VueCountdown', VueCountdown)
Vue.config.productionTip = false

Vue.component('defaultlayout', DefaultLayout)
Vue.component('loginlayout', LoginLayout)
Vue.component('examlayout', ExamLayout)
Vue.loadScript('js/vendors.bundle.js')
Vue.loadScript('js/scripts.bundle.js')

Vue.filter('formatTime', function (value) {
  console.log(value);
  const sec = parseInt(value, 10); // convert value to number if it's string
  let hours = Math.floor(sec / 3600); // get hours
  let minutes = Math.floor((sec - (hours * 3600)) / 60); // get minutes
  let seconds = sec - (hours * 3600) - (minutes * 60); //  get seconds
  // add 0 if value < 10; Example: 2 => 02
  if (hours < 10) {hours = "0"+hours;}
  if (minutes < 10) {minutes = "0"+minutes;}
  if (seconds < 10) {seconds = "0"+seconds;}
  return hours+':'+minutes+':'+seconds; // Return is HH : MM : SS
})

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
